import React from 'react';

import SummaryCard from './SummaryCard';

import { AlarmRulesCount } from 'types/types';

interface Props {
  alarmsCount: AlarmRulesCount;
}

const Summary: React.FC<Props> = ({ alarmsCount }) => {
  const summary = [
    {
      title: 'All Alarms',
      count: alarmsCount.AllAlarms,
    },
    {
      title: 'Active Alarms',
      count: alarmsCount.ActiveAlarms,
    },
    {
      title: 'Paused Alarms',
      count: alarmsCount.PausedAlarms,
    },
  ];
  return (
    <div className="summary-container">
      {summary.map((el, index) => (
        <SummaryCard key={index} summaryItem={el} />
      ))}
    </div>
  );
};

export default Summary;
